import { PlatformPage } from './PlatformPage'
import { platformFeatures } from '@/data/platform'

export default function Templates() {
  return <PlatformPage feature={platformFeatures['templates']!} />
}
